export default __webpack_public_path__ + "static/media/10.4f020ab6.jpg";